<template>
    <div class="video-player-page">
        <div class="mb-4 flex justify-between">
            <router-link
                to="/nice"
                class="bg-blue-100 text-blue-700 hover:bg-blue-200 px-4 py-2 rounded flex items-center"
            >
                <i class="bi-arrow-left mr-2"></i> Zurück zur Videodeduplikation
            </router-link>
        </div>

        <v-card>
            <v-card-title>
                {{ $t('media.videoPlayer.title') }}
                <div class="text-subtitle-1 text-grey">{{ clientId }}</div>
            </v-card-title>

            <v-card-text>
                <VideoPlayer :client-id="clientId" width="100%" height="480px" />

                <!--

                <v-divider class="my-4"></v-divider>

                <div class="duplicate-videos">
                    <div class="mb-4">
                        <h3 class="text-h6">{{ $t('media.videoPlayer.duplicateVideos') }}</h3>
                    </div>

                    <div v-if="duplicateVideos.length > 0">
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div
                                v-for="duplicate in duplicateVideos"
                                :key="duplicate.id"
                                class="border border-gray-200 rounded-lg p-3"
                            >
                                <div
                                    class="relative aspect-video bg-gray-100 mb-2 overflow-hidden rounded"
                                >
                                    <router-link :to="`/media/player/${duplicate.id}`">
                                        <img
                                            :src="getThumbnailUrl(duplicate.id)"
                                            class="w-full h-full object-cover"
                                            alt="Video thumbnail"
                                        />
                                        <div
                                            class="absolute inset-0 bg-black bg-opacity-30 opacity-0 hover:opacity-100 transition-opacity flex items-center justify-center"
                                        >
                                            <div class="text-white font-bold">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    class="w-12 h-12"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                                                        clip-rule="evenodd"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </router-link>

                                    <div
                                        class="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-sm px-2 py-1 rounded"
                                    >
                                        {{ Math.round(duplicate.similarity * 100) }}% Match
                                    </div>
                                </div>

                                <div class="text-sm font-medium truncate">
                                    {{ duplicate.title }}
                                </div>
                                <div class="flex justify-between mt-2">
                                    <router-link
                                        :to="`/media/player/${duplicate.id}`"
                                        class="text-xs bg-blue-100 text-blue-700 hover:bg-blue-200 px-2 py-1 rounded"
                                    >
                                        Abspielen
                                    </router-link>
                                    <button
                                        class="text-xs bg-gray-100 text-gray-700 hover:bg-gray-200 px-2 py-1 rounded"
                                    >
                                        Vergleichen
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="bg-gray-50 p-4 rounded text-center text-gray-500">
                        Keine Duplikate für dieses Video gefunden
                    </div>
                </div>

                This could be a neat feature    -->

            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, watch, onMounted, nextTick } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useMediaStore } from '@/utils/useMediaStore'
    import VideoPlayer from '@/components/Media/VideoPlayer.vue'

    export default defineComponent({
        name: 'VideoPlayerView',

        components: {
            VideoPlayer,
        },

        setup() {
            const route = useRoute()
            const router = useRouter()
            const mediaStore = useMediaStore()

            // Get client ID from route params or fallback to demo value
            const clientId = computed(() => {
                return String(route.params.id || 'demo-video-id')
            })

            // Computed duplicate videos from store
            const duplicateVideos = computed(() => {
                if (clientId.value && mediaStore.duplicateVideos[clientId.value]) {
                    return mediaStore.duplicateVideos[clientId.value]
                }
                return []
            })

            // Generate a thumbnail URL based on ID
            const getThumbnailUrl = (id: string): string => {
                // In a real implementation, you would use actual thumbnails from your API
                // For demo purposes, we'll generate a placeholder image
                const hash = id.split('').reduce((a, b) => {
                    a = (a << 5) - a + b.charCodeAt(0)
                    return a & a
                }, 0)

                // Use a placeholder image service with a hash to get consistent images for same IDs
                return `https://picsum.photos/seed/${Math.abs(hash)}/640/360`
            }

            // Play video when component mounts or ID changes
            watch(
                clientId,
                (id) => {
                    if (id) {
                        mediaStore.playVideo(id)

                        // Scroll to top when client ID changes
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }
                },
                { immediate: true }
            )

            // Ensure page scrolls to top when component is mounted
            onMounted(() => {
                nextTick(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' })
                })
            })

            return {
                clientId,
                duplicateVideos,
                getThumbnailUrl,
            }
        },
    })
</script>

<style scoped>
    .video-player-page {
        max-width: 1200px;
        margin: 0 auto;
    }

    .player-settings,
    .recent-videos {
        margin-top: 24px;
    }
</style>
